import React from "react";
import styles from "../HeroComponent/HeroComponent.module.css";
import AnimatedBtn from "../../AnimatedBtn/AnimatedBtn";
import StartNowBtn from "../../StartNowBtn/StartNowBtn";
import MobileAnimate from "./MobileAnimate";
import { PortableText } from "@portabletext/react";
const HeroComponent = (props) => {
  const data = props?.hero?.hero ?? props?.hero ?? props;
  const {
    enabled = true,
    headlineLine = [],
    headlinePlain = "",
    subheading = "",
    primaryCta = {},
    featurePills = [],
  } = data || {};

  const ptComponents = {
    marks: {
      purple: ({ children }) => (
        <span style={{ color: "#6524EB" }}>{children}</span>
      ),
      strong: ({ children }) => <strong>{children}</strong>,
      break: ({ children }) => (
        <>
          {children}
          <br />
        </>
      ),
    },
    list: {
      bullet: ({ children }) => <ul className="list-disc ml-6">{children}</ul>,
      number: ({ children }) => (
        <ol className="list-decimal ml-6">{children}</ol>
      ),
    },
  };

  const colorClasses = [styles.yellow, styles.green, styles.blue];
  const animationClasses = [
    styles.AnimationCall,
    styles.AnimationLanguage,
    styles.AnimationInteraction,
  ];

  const colorAt = (i) => colorClasses[i % colorClasses.length];
  const animAt = (i) => animationClasses[i % animationClasses.length];
  return (
    <div className={styles.containerBox}>
      <div className={styles.UpperDiv}>
        <div className={styles.LeftSection}>
          <div className={styles.ContentDiv}>
            <h1 className={styles.Title}>
              <PortableText value={headlineLine} components={ptComponents} />
            </h1>
            <p className={styles.Description}>{subheading}</p>
            <div
              className={styles.BtnDiv}
              onClick={() =>
                window.open(
                  "https://app.rxpt.ai/",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              {/* <AnimatedBtn text="Get Started for FREE" /> */}
              <StartNowBtn
                mainText="FREE SIGNUP"
                subText="No Credit Card needed"
                underline=""
                bold=""
              />
            </div>
          </div>
        </div>
        <div className={styles.RightSection}>
          <div className={styles.RightImg}>
            <div className={styles.container}>
              <div className={styles.left}>
                {featurePills.slice(0, 2).map((pill, i) => (
                  <div
                    key={pill?.label || i}
                    className={`${styles.section} ${colorAt(i)}`}
                  >
                    <div className={`${styles.icon} ${animAt(i)}`}>
                      {pill?.icon?.src ? (
                        <img
                          src={pill.icon.src}
                          alt={pill?.icon?.alt || pill?.label || "feature"}
                        />
                      ) : (
                        <img
                          src={
                            i === 0
                              ? "/Svg/Call-First.svg"
                              : "/Svg/language-icon.svg"
                          }
                          alt={pill?.label || "feature"}
                        />
                      )}
                    </div>
                    <h3 className={styles.Bold}>{pill?.label}</h3>
                  </div>
                ))}

                <div className={styles.sectionImage}>
                  <MobileAnimate />
                </div>

                <div className={`${styles.section} ${styles.blue}`}>
                  <div
                    className={`${styles.icon} ${styles.AnimationInteraction}`}
                  >
                    <img
                      src="/Svg/Effortless-Integration.svg"
                      alt="Effortless Integration"
                    />
                  </div>
                  <h3 className={styles.Bold}>Effortless Integration</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroComponent;
